import { FC } from 'react';
import { ControlProps, GroupBase, OptionProps, PlaceholderProps, components } from 'react-select';

import { ControlStyled, OptionStyled, PlaceholderStyled } from './Select.styled';
import { SelectOptionT } from 'declarations/types/select';

const Control: FC<ControlProps<SelectOptionT, false, GroupBase<SelectOptionT>>> = props => {
  const { children } = props;

  return (
    <components.Control {...props} getStyles={() => ({})}>
      <ControlStyled>{children}</ControlStyled>
    </components.Control>
  );
};

const Placeholder: FC<PlaceholderProps<SelectOptionT, false, GroupBase<SelectOptionT>>> = props => {
  const { children } = props;

  return (
    <components.Placeholder {...props}>
      <PlaceholderStyled size="xl">{children}</PlaceholderStyled>
    </components.Placeholder>
  );
};

const Option: FC<OptionProps<SelectOptionT, false, GroupBase<SelectOptionT>>> = props => {
  const { children, isFocused, isSelected } = props;

  return (
    <components.Option {...props} getStyles={() => ({})}>
      <OptionStyled isFocused={isFocused} isSelected={isSelected}>
        {children}
      </OptionStyled>
    </components.Option>
  );
};

export { Control, Placeholder, Option };
